import { gql } from 'apollo-angular';

export interface AvailableCustomersResponse {
  availableCustomers: AvailableCustomerModel[];
}

export interface AvailableCustomerModel {
  id: number;
  fullName: string;
  aliasName: string;
  subdomain: string;
}

export const AVAILABLE_CUSTOMERS_QUERY = gql`
  query availableCustomers {
    availableCustomers {
      id
      fullName
      aliasName
      subdomain
    }
  }
`;
